import { map, OperatorFunction } from 'rxjs';

type Voidable = undefined | null;

export function nullify<T>(): OperatorFunction<T | Voidable, T | null> {
  return map((value) => (value ? value : null));
}
